import React, { useState } from 'react'
import axios from 'axios'
import moment from 'moment-jalaali'
import './style.css'
import '../../videocall/modal-vidobo/index.css'
import { useEffect } from 'react'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'

function ExpiredPanelModal() {

    return (
        <div className='modal-background'>
            <div className='modal-container'>
                <div className='modal-title'>
                    افزودن کاربر
                </div>
                <div className='users-modal-title mode-text-7'>
                زمان باقیمانده از پنل شما به اتمام رسیده است.
                </div>
                <div className='users-modal-title mode-text-7'>
                لطفا جهت تمدید اکانت به صفحه‌ی خرید محصولات مراجعه فرمایید.
                </div>
                <div className='modal-footer mode-bg-8'>
                    <button onClick={() => window.location.href = '/fa/panel/store'}>
                        خرید
                    </button>
                    <button onClick={() =>{ window.location.href = '/fa/login'; localStorage.setItem('token', null)}}>
                        خروج
                    </button>
                </div>
                <div className='error-text'>
                    
                </div>
            </div>
        </div>
    )
}

export default ExpiredPanelModal